import { SPBlockedReport } from './types';

const SP_MARKER_IDS = ['REQUEST-DATE', 'REQUEST-IP', 'REQUEST-ID'] as const;

const SP_FIELD_PREFIXES: Record<keyof Omit<SPBlockedReport, 'html'>, string> = {
    datetime: 'Datetime:',
    ip: 'IP:',
    id: 'ID:',
};

export const isHtmlResponse = (data: unknown, contentType?: string): data is string => {
    if (typeof data !== 'string') {
        return false;
    }

    if (contentType?.toLowerCase().includes('text/html')) {
        return true;
    }

    const trimmed = data.trim().toLowerCase();

    return trimmed.startsWith('<!doctype html') || trimmed.startsWith('<html');
};

const isSPBlockedHtml = (html: string): boolean => {
    return SP_MARKER_IDS.every((markerId) => html.includes(`id="${markerId}"`));
};

const extractElementText = (html: string, elementId: string): string | undefined => {
    const match = html.match(new RegExp(`<p\\s+id="${elementId}"[^>]*>([^<]*)</p>`, 'i'));

    return match?.[1]?.trim() || undefined;
};

const stripPrefix = (value: string, prefix: string): string => {
    return value.startsWith(prefix) ? value.slice(prefix.length).trim() : value;
};

const parseSPReport = (html: string): SPBlockedReport | null => {
    const datetimeRaw = extractElementText(html, 'REQUEST-DATE');
    const ipRaw = extractElementText(html, 'REQUEST-IP');
    const idRaw = extractElementText(html, 'REQUEST-ID');

    if (!datetimeRaw || !ipRaw || !idRaw) {
        return null;
    }

    return {
        html,
        datetime: stripPrefix(datetimeRaw, SP_FIELD_PREFIXES.datetime),
        ip: stripPrefix(ipRaw, SP_FIELD_PREFIXES.ip),
        id: stripPrefix(idRaw, SP_FIELD_PREFIXES.id),
    };
};

export const parseSPBlockedResponse = (
    data: unknown,
    contentType?: string,
): SPBlockedReport | null => {
    if (!isHtmlResponse(data, contentType)) {
        return null;
    }

    if (!isSPBlockedHtml(data)) {
        return null;
    }

    return parseSPReport(data);
};
